<div class="no-print-message">Printing is disabled for this page.</div>

<div
  *ngIf="service.isLoadingFormInstance || !service.formInstance"
  class="vh-100 d-flex justify-content-center align-items-center"
>
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div *ngIf="!service.isLoadingFormInstance && service.formInstance">
  <div
    *ngIf="!!service.formInstance?.isPreviewData"
    class="preview-body-title d-flex white-txt justify-content-center align-items-center mb-0"
  >
    <h2>Preview mode</h2>
  </div>

  <app-public-header
    [showCFEPLogo]="service.themeService.showCFEPLogo"
    [cobrandedLogo]="
      service.formInstance.formGroupInstance.companyWithOnlineLogo?.onlineLogoSignedUrl
    "
  />

  <ng-container *ngIf="service.currentState === states.Intro">
    <ng-container *ngTemplateOutlet="intro" />
  </ng-container>

  <ng-container *ngIf="service.currentState === states.Progress">
    <ng-container *ngTemplateOutlet="form" />
  </ng-container>

  <ng-container *ngIf="service.currentState === states.ThankYou">
    <ng-container *ngTemplateOutlet="thankyou" />
  </ng-container>

  <div
    *ngIf="service.isSubmitting"
    class="overlay d-flex align-items-center justify-content-center"
  >
    <div class="spinner-border text-white" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <ng-template #intro>
    <div
      class="page-content survey-star"
      [ngStyle]="{
        'background-image': service.themeService.getBackgroundThemeImage()
          ? 'url(' + service.themeService.getBackgroundThemeImage() + ')'
          : 'none',
        'background-position': 'top center',
        'background-repeat': 'no-repeat',
        'background-size': 'cover'
      }"
    >
      <div class="row">
        <div class="col-md-6">
          <h3>{{ service.formInstance.name }}</h3>
          <h3 *ngIf="service.formInstance.formTemplate.formTemplateCategory.isPAIS">
            {{ service.formInstance.formGroupInstance.primaryCompany?.name }}
          </h3>
          <h3 *ngIf="service.formInstance.subject">
            {{ service.formInstance.subject.contactLabel(true) }}
          </h3>
          <div [innerHTML]="service.formInstance.introText | safeHtml"></div>
          <button
            *ngIf="
              service.formInstance.formTemplate &&
              service.formInstance.formTemplate.isValidForCompletion
            "
            class="btn-deal d-flex gap-1"
            type="button"
            (click)="service.startFormInstance()"
            [ngClass]="{
              'hover-highlight': !!service.themeService.getThemeColor(ThemeItemEnum.startButton)
            }"
            [ngStyle]="{
              'background-color': service.themeService.getThemeColor(ThemeItemEnum.startButton)
            }"
          >
            Start Survey<mat-icon svgIcon="arrow-right" />
          </button>
          <div *ngIf="!isProduction">S2 PSID:{{ service.formInstance.id }}</div>
          <div class="scan" *ngIf="service.formInstance.qrCode">
            <div class="qrcode">
              <img [src]="service.formInstance.qrCode" />
            </div>
            <span>Or scan to complete the survey on your device</span>
          </div>
        </div>
        <div *ngIf="service.imageSignedURL" class="col-md-6 img-side">
          <img [src]="service.imageSignedURL" alt="Questionnaire image" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #form>
    <div class="container-fluid">
      <form
        #form="ngForm"
        class="page-content questionnaire-wrap mb-5"
        [formGroup]="service.formGroup"
        novalidate
        (ngSubmit)="service.submitFormInstance()"
      >
        <app-form-completion-template [formTemplate]="service.formInstance.formTemplate" />
      </form>
    </div>
  </ng-template>

  <ng-template #thankyou>
    <div
      class="page-content survey-star"
      [ngStyle]="{
        'background-image': service.themeService.getBackgroundThemeImage()
          ? 'url(' + service.themeService.getBackgroundThemeImage() + ')'
          : 'none',
        'background-position': 'top center',
        'background-repeat': 'no-repeat',
        'background-size': 'cover'
      }"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="thankyou">
            <div
              *ngIf="!!service.formInstance.formTemplate.onlineThankyouMessage"
              [innerHTML]="service.formInstance.formTemplate.onlineThankyouMessage | safeHtml"
              class="my-4 onlineThankyouMessage"
            ></div>
            <img
              *ngIf="!!service.themeService.showCFEPLogo"
              class="logo"
              src="assets/images/CFEP-logo.png"
              alt="cfep-logo"
            />
            <img
              *ngIf="
                !!service.formInstance.formGroupInstance.companyWithOnlineLogo?.onlineLogoSignedUrl
              "
              class="logo"
              [src]="
                service.formInstance.formGroupInstance.companyWithOnlineLogo?.onlineLogoSignedUrl
              "
              alt="cobranded-logo"
            />
            <span>Thank you for your feedback</span>
            <p>
              If you have questions about this survey, please contact Client Focused Evaluation
              Program (CFEP) Surveys
            </p>
            <div class="social">
              <a href="tel:0738552093">
                <img src="assets/images/phone-icon.png" />
                (07) 3855 2093
              </a>
              <a href="mail:info@cfepsurveys.com.au">
                <img src="assets/images/mail-icon.png" />
                info&#64;cfepsurveys.com.au
              </a>
              <a href="mail:cfepsurveys.com.au">
                <img src="assets/images/globe-icon.png" />
                cfepsurveys.com.au
              </a>
            </div>
            <button
              *ngIf="!service.formInstance.isCFET && !service.formInstance.isSA"
              class="return-bck"
              (click)="service.restartFormInstance()"
              [ngClass]="{
                'hover-highlight': !!service.themeService.getThemeColor(ThemeItemEnum.restartButton)
              }"
              [ngStyle]="{
                'background-color': service.themeService.getThemeColor(
                  service.themeService.ThemeItemEnum.restartButton
                )
              }"
            >
              Start new survey <img src="assets/images/return-icon.png" />
            </button>
          </div>
        </div>
        <div *ngIf="service.imageSignedURL" class="col-md-6 img-side">
          <img [src]="service.imageSignedURL" alt="Questionnaire image" />
        </div>
      </div>
    </div>
  </ng-template>
</div>
